import { Box, Button, CircularProgress, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import CodeIcon from "@mui/icons-material/Code";
import React, { useEffect, useState } from "react";
import axios from "axios";

const EboSohDaily = () => {
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();
	const [loading, setLoading] = useState(false);

	const [brand, setBrand] = useState("SELECT");

	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			await axios.get(`/api/custom_queries/ebo-soh-daily-data?brand=${brand}`).then((res) => {
				const updatedData = res.data;
				if (res.status === 200) {
					setLoading(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "file saved successfully in data hub",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				} else if (res.status === 204) {
					setLoading(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: res.statusText,
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				}
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "failed to run query",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
		}
	};

	return (
		<Stack spacing={2} component="form" onSubmit={handleRunQueryClick}>
			{/* <Typography variant="h6">EBO SOH Daily Data</Typography> */}
			{/* form */}
			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2} pt={2}>
				<Stack spacing={1}>
					<InputLabel>Brand</InputLabel>
					<Select
						value={brand}
						onChange={(e) => setBrand(e.target.value.toUpperCase())}
						sx={{ width: "200px" }}
						size="small">
						<MenuItem value={"SELECT"}>SELECT</MenuItem>
						<MenuItem value={"RARE RABBIT"}>RARE RABBIT</MenuItem>
						<MenuItem value={"RAREISM"}>RAREISM</MenuItem>
					</Select>
				</Stack>
			</Box>
			<Button
				variant="contained"
				disabled={loading}
				sx={{ width: "200px" }}
				type="submit"
				startIcon={loading ? <CircularProgress color="inherit" size="20px" /> : <CodeIcon />}>
				{loading ? "Loading..." : "Run"}
			</Button>
		</Stack>
	);
};

export default EboSohDaily;
